module.exports = __webpack_public_path__ + "img/ico-filter.32836b30.svg";